var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOften(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5429 7.72793C30.3482 8.60079 30.295 9.96079 29.424 10.7681L16.0009 23.2094L11.4432 27.4336L2.47273 17.8606C1.65936 16.9926 1.70365 15.6295 2.57165 14.8162L3.70469 13.7545C4.57273 12.9411 5.9358 12.9854 6.74916 13.8535L11.7403 19.1804L16.0009 15.2283L25.4428 6.46892C26.3165 5.65832 27.6825 5.71143 28.4907 6.58743L29.5429 7.72793Z",
    fill: "#64AB88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5429 7.72793C30.3482 8.60079 30.295 9.96079 29.424 10.7681L16.0009 23.2094V15.2283L25.4428 6.46892C26.3165 5.65832 27.6825 5.71143 28.4907 6.58743L29.5429 7.72793Z",
    fill: "#429E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOften);
export default __webpack_public_path__ + "static/media/often.0dcb80a5f5e3b436196db7addca36615.svg";
export { ForwardRef as ReactComponent };